import { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import Spinner from 'react-bootstrap/Spinner';
import { handleApiRequest } from '../utils/apiHandler';
import api from '../services/axios';

const CardForm = ({ onCardAdded, userId, onError }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements || !userId) {
      // Stripe.js has not yet loaded.
      return;
    }

    setIsSubmitted(true);

    await handleApiRequest({
      requestFn: () => api.post(`/manager/users/${userId}/setup-intent`),
      onSuccess: async (res) => {
        let email = res.email;
        let client_secret = res.client_secret;
        if (!email || !client_secret) return;

        const cardElement = elements.getElement(CardElement);

        // Confirming the card setup
        const { setupIntent, error } = await stripe.confirmCardSetup(
          client_secret,
          {
            payment_method: {
              card: cardElement,
              billing_details: { email: email },
            },
          }
        );
        setIsSubmitted(false);

        if (error) {
          console.error('[error]', error);
          onError(error.message);
        } else {
          if (setupIntent?.status === 'succeeded') {
            cardElement.clear();
            onCardAdded();
          }
        }
      },
      onError: (error) => {
        setIsSubmitted(false);
        onError(error);
      },
      finallyFn: () => {
        setIsSubmitted(false);
      },
    });
  };

  return (
    <form onSubmit={handleSubmit} align="center">
      <div className="mb-2" align="center">
        <div style={{ maxWidth: '400px' }}>
          <CardElement
            options={{
              hidePostalCode: true,
              style: {
                base: {
                  fontSize: '16px',
                  color: '#32325d',
                },
              },
            }}
            onChange={(event) => {
              setButtonDisabled(!event.complete);
            }}
          />
        </div>
      </div>
      <button
        type="submit"
        className="btn btn-primary"
        disabled={buttonDisabled}
      >
        {isSubmitted ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            &nbsp;Adding Card...
          </>
        ) : (
          'Add Card'
        )}
      </button>
    </form>
  );
};

export default CardForm;
